import WordBox from "../../../basic/wordBox/WordBox";
import type { StudentResultExercise } from "../../../helpers/StudentResultModel";

interface StudentResultExerciseDescriptionProps {
    exercise: StudentResultExercise;
}

/**
 * Drill-in slot: the word box and the helper sentence, in the order the student met them during the
 * test. A table exercise has neither and renders nothing at all — no label for an empty slot. The
 * task itself belongs to StudentResultExerciseFrame, and the rule below to ExerciseCardDivider.
 */
const StudentResultExerciseDescription = (props: StudentResultExerciseDescriptionProps) => {
    // Blank-only pools must render nothing, not an empty box.
    const wordBox = (props.exercise.wordBox ?? []).filter((word) => word.trim());
    const helperSentence = props.exercise.helperSentence?.trim();

    if (!wordBox.length && !helperSentence) {
        return null;
    }

    return (
        <div
            className="flex flex-col gap-s"
            data-testid="student-result-exercise-description"
        >
            <WordBox words={wordBox} />
            {helperSentence && <p className="text-l text-p6-grey-dark italic px-xs">{helperSentence}</p>}
        </div>
    );
};

export default StudentResultExerciseDescription;
